import config from '../config';

/**
 * Record a member activity event for weekly analytics.
 * Fire-and-forget: never blocks navigation or magazine open.
 * @param {'magazine_card' | 'read_now'} event
 */
export const trackMemberActivity = (event) => {
  try {
    const token = localStorage.getItem('userToken');
    if (!token || !event) return;

    const apiUrl = config.getApiUrl();
    fetch(`${apiUrl}/api/member-analytics/track`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({ event })
    }).catch((err) => {
      console.warn('Member activity tracking failed:', err);
    });
  } catch (err) {
    console.warn('Member activity tracking failed:', err);
  }
};
